
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AirportAttributes } from '../../../typings/features/airport-attributes';
import { AbstractDetailComponent } from '../abstract-detail.component';
@Component({
  selector: 'jmkw-airport-detail',
  standalone: true,
  imports: [],
  templateUrl: './airport-detail.component.html',
  styleUrls: ['./airport-detail.component.scss', '../nav-widgets.shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AirportDetailComponent extends AbstractDetailComponent<AirportAttributes> {
  @Input() attributes!: AirportAttributes;
}
